import "./modules/jquery_global";
import "@hotwired/turbo-rails";

// TODO: disabled explicitly for now, make sure it doesn't break anything before removing
Turbo.session.drive = false;
// Currently breaks:
// Orders#index

// Turbo 8 intercepts form submits via event.preventDefault() even when drive=false,
// then abandons the fetch — so forms never navigate. Fix: mark non-frame forms as
// data-turbo="false" in the capture phase (before Turbo's bubble-phase listener runs)
// so native browser submission takes over. Frame-targeted forms are excluded — they
// still use Turbo for scoped frame updates.
// TODO: remove once Turbo Drive is re-enabled.
document.addEventListener(
  "submit",
  ({ target }) => {
    if (target instanceof HTMLFormElement && !target.dataset.turboFrame) {
      target.setAttribute("data-turbo", "false");
    }
  },
  true
);

import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();
application.debug = false;
window.StimulusApp = application;
const controllers = import.meta.glob("./controllers/**/*_controller.js", {
  eager: true
});
registerControllers(application, controllers);

import "trix";
import "trix/dist/trix.css";

// TODO: - need to find some proper solution to avoid ordering problems.
// These two pull in vendor CSS (viewer.css via gallery.js, flatpickr's own
// CSS) that our own overrides need to load after, so they're imported
// before application.scss — matching how tom-select/toastr already work.
import "./modules/gallery";
import "./modules/datepicker";

import "../styles/application.scss";

import "./helpers";
import "./modules/order_labels";
import "./modules/generating_button";
import "./modules/trix_autolink";
import "./modules/disable_action_triggers";
import "./modules/users_edit";
